import React from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const CreationCard = ({ service, name, description, icon, badge, index = 0 }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const Icon = Icons[icon] || Icons.Sparkles;

  const go = () => navigate(user ? `/create/${service}` : "/login");

  return (
    <button
      data-testid={`creation-card-${service}`}
      onClick={go}
      style={{ animationDelay: `${index * 60}ms` }}
      className="studio-card animate-fade-up group flex flex-col items-start p-6 text-left"
    >
      <div className="flex w-full items-center justify-between">
        <span className="grid h-12 w-12 place-items-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
          <Icon className="h-6 w-6" />
        </span>
        {badge && (
          <span className="rounded-full bg-secondary px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">{badge}</span>
        )}
      </div>
      <h3 className="mt-5 text-lg font-bold">{name}</h3>
      <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      <span className="mt-4 inline-flex items-center text-sm font-semibold text-primary opacity-0 transition-opacity group-hover:opacity-100">
        Start <Icons.ArrowRight className="ml-1 h-4 w-4" />
      </span>
    </button>
  );
};
